import Alert from '@/common/components/Alert'
import ResumeItem from '@/common/components/ResumeItem'
import { formatDateTime } from '@/common/utils/formatters'
import ExecutionObjectiveItem from '@/features/maintenanceWorkflow/pages/Show/features/directiveEntries/features/execution/components/ExecutionObjectiveItem'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { CircleAlertIcon } from 'lucide-react'

const DirectiveEntryExecutionEntryCompleted = () => {
  const { forwarding } = useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>()

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {forwarding.directive_entry?.completed_at && (
            <ResumeItem
              label="Manutenção finalizada"
              value={formatDateTime(new Date(forwarding.directive_entry?.completed_at))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>

        <Alert variant="warning" Icon={CircleAlertIcon} iconClassName="size-6" containerClassName="bg-transparent p-0">
          <p className="text-sm">
            Esse serviço já foi executado e será faturado após aprovação das suas notas fiscais.
          </p>
        </Alert>

        <div className="flex flex-col gap-2">
          <p className="font-bold">Checklist da manutenção</p>

          <div className="flex flex-col gap-1.5">
            {forwarding?.directive_entry?.objectives?.map((objective) => (
              <ExecutionObjectiveItem key={objective.id} objective={objective} isInAwaitingClientReview={false} />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default DirectiveEntryExecutionEntryCompleted
